import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API } from "../services/api";

const initialState = {
  isLoading: false,
  userInfo: null,
  error: null,
  success: false,
};

const isLoading = (action) => {
  return ["auth/register/pending"].includes(action.type);
};

const isFinishLoading = (action) => {
  return ["auth/register/fulfilled", "auth/register/rejected"].includes(
    action.type
  );
};

const isRejected = (action) => {
  return ["auth/register/rejected"].includes(action.type);
};

export const register = createAsyncThunk(
  "auth/register",
  async (values, { rejectWithValue }) => {
    try {
      const { data } = await API.post(
        "/Accounts/RegisterAccount",
        JSON.stringify(values)
      );
      return data;
    } catch (e) {
      return rejectWithValue(e.response.data);
    }
  }
);

export const authSlice = createSlice({
  name: "auth",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(register.fulfilled, (state, action) => {
        if (action.payload.description === "Success") {
          state.success = true;
        }
      })
      .addMatcher(isLoading, (state, action) => {
        state.isLoading = true;
        state.error = null;
      })
      .addMatcher(isRejected, (state, action) => {
        state.error = action.payload;
        state.isLoading = false;
        state.success = false;
      })
      .addMatcher(isFinishLoading, (state, action) => {
        state.isLoading = false;
      });
  },
});

export default authSlice.reducer;
